import React, { useEffect, useState } from 'react';
import './VersionDisplay.css';

function VersionDisplay() {
  const [versions, setVersions] = useState({
    engine: '...',
    app: '...'
  });

  useEffect(() => {
    const fetchVersions = async () => {
      try {
        const response = await fetch('/api/version');
        
        if (response.ok) {
          const data = await response.json();
          if (data && data.engine && data.app) {
            setVersions({
              engine: data.engine,
              app: data.app
            });
          }
        }
      } catch (error) {
        console.error('Error fetching versions:', error);
      }
    };

    fetchVersions();
  }, []);

  return (
    <footer className="version-footer">
      <div className="version-section">
        <span>MyJava Engine Ver: {versions.engine}</span>
        <span>App Version: {versions.app}</span>
      </div>
      <div className="copyright-section">
        <span className="copyright-main">Copyright © 2025 <a href="https://myjava.ai/" target="_blank" rel="noopener noreferrer">MyJava.ai</a></span>
        <span className="rights-reserved"> - All Rights Reserved.</span>
      </div>
    </footer>
  );
}

export default VersionDisplay;